import { BrowserCacheLocation, LogLevel } from '@azure/msal-browser';

const authLocal = {
    clientId: 'ce1bba86-b4e0-49e2-a259-1f12c619fd2a',
    authority: 'https://login.microsoftonline.com/8ac76c91-e7f1-41ff-a89c-3553b2da2c17/',
    redirectUri: '/',
    postLogoutRedirectUri: '/'
}
const authDev = {
    clientId: '9a6358e4-63a7-4947-93de-e4df2d3aef1e',
    authority: 'https://login.microsoftonline.com/8ac76c91-e7f1-41ff-a89c-3553b2da2c17/',
    redirectUri: '/',
    postLogoutRedirectUri: '/'
}

const msalConfig = {
    auth: {
        clientId: '',
        authority: '',
        redirectUri: '',
        postLogoutRedirectUri: ''
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        return;
                    case LogLevel.Warning:
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const authConfig = {
    getMSALConfig: () => {
        const currentUrl = window.location.href
        if (currentUrl.startsWith('https://stg-contentrocket.wolterskluwer.com') ||
            currentUrl.startsWith('https://dev-contentrocket.wolterskluwer.com') ||
            currentUrl.startsWith('https://qa-contentrocket.wolterskluwer.com') ||
            currentUrl.startsWith('https://contentrocket.wolterskluwer.com')) {
            Object.assign(msalConfig.auth, authDev);
        } else {
            Object.assign(msalConfig.auth, authLocal);
        }
        return msalConfig;
    }
}

export const loginRequest = {
    scopes: ["User.Read"]
};